<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>{{ __("Loading...") }}</strong>
            <div
                class="spinner-border ml-auto"
                role="status"
                aria-hidden="true"
            ></div>
        </div>

        <div v-else class="enqContent">
            <i v-if="disabled" class="fragment-disabled"></i>
            <form
                autocomplete="off"
                @submit.prevent="onSubmit"
                class="form form-inline"
                role="form"
            >
                <div
                    class="form-group align-items-center mb-1 w-100"
                    v-if="
                        enquiry.enquiryStatusID !== 1 &&
                        authed.permissions.includes('access reports') &&
                        authed.permissions.includes('user activity report')
                    "
                >
                    <label
                        for="history"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Enquiry History") }}</strong>
                    </label>
                    <label
                        for="history"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Enquiry History") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="history"
                            class="a-input"
                            href="#"
                            @click="showHistory"
                            >{{ __("Click Here") }}</a
                        >
                    </div>
                </div>

                <div
                    v-if="
                        splitable && authed.permissions.includes('split orders')
                    "
                    class="form-group align-items-center mb-1 w-100"
                >
                    <label
                        for="split"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Split Order") }}</strong>
                    </label>
                    <label
                        for="split"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Split Order") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="split"
                            class="a-input"
                            href="#"
                            @click="showSplit"
                            >{{ __("Click Here") }}</a
                        >
                    </div>
                </div>

                <div
                    v-if="isOrder && validInvoice"
                    class="form-group align-items-center mb-1 w-100"
                >
                    <label
                        for="invoice"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Invoice Date") }}</strong>
                    </label>
                    <label
                        for="invoice"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Invoice Date") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="text"
                            autocomplete="off"
                            v-model="formattedInvoice"
                            class="form-control w-100"
                            id="invoice"
                            :disabled="disabled"
                            readonly
                        />
                    </div>
                </div>

                <div
                    class="form-group align-items-center mb-1 w-100"
                    v-if="!isOrder"
                >
                    <label
                        for="selectedReferralMethod"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Referral Method") }}</strong>
                    </label>
                    <label
                        for="selectedReferralMethod"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Referral Method") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="selectedReferralMethod"
                            id="selectedReferralMethod"
                            class="form-control w-100 custom-select"
                            :disabled="
                                disabled || 1 === enquiry.referral_method_id
                            "
                            required
                        >
                            <option
                                v-if="0 === enquiry.referral_method_id"
                                :value="0"
                                selected
                                disabled
                            >
                                {{ __("Please Select") }}
                            </option>

                            <option
                                v-if="1 === enquiry.referral_method_id"
                                :value="1"
                                selected
                            >
                                {{ __("Website") }} ({{
                                    enquiry.referralMethodSource
                                }})
                            </option>

                            <option
                                v-else
                                v-for="method in referralMethods"
                                :key="method.ID"
                                :value="method.ID"
                            >
                                {{ __(method.referralMethod) }}
                            </option>
                        </select>
                    </div>
                </div>

                <div
                    class="form-group align-items-center mb-1 w-100"
                    v-if="customersNotes && '' !== customersNotes"
                >
                    <label
                        for="customersNotes"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Customer Notes") }}</strong>
                    </label>
                    <label
                        for="customersNotes"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Customer Notes") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <textarea
                            v-model="customersNotes"
                            class="form-control w-100"
                            id="customersNotes"
                            rows="8"
                            :disabled="disabled"
                            readonly
                        ></textarea>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="selectedTemplateID"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Document Templates") }}</strong>
                    </label>
                    <label
                        for="selectedTemplateID"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Document Templates") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="selectedTemplateID"
                            id="selectedTemplateID"
                            class="form-control w-100 custom-select"
                            :disabled="disabled"
                        >
                            <option
                                v-for="code in languageCodes"
                                :key="code.ID"
                                :value="code.ID"
                                :disabled="
                                    code.ID !== 2 && APP_LOCALE === 'en_US'
                                "
                            >
                                {{ code.languageCode }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="theirReferenceNumber"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Their Reference Number") }}</strong>
                    </label>
                    <label
                        for="theirReferenceNumber"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Their Reference Number") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="text"
                            autocomplete="off"
                            maxlength="50"
                            v-model="theirReferenceNumber"
                            class="form-control w-100"
                            id="theirReferenceNumber"
                            :disabled="disabled"
                            data-lpignore="true"
                        />
                    </div>
                </div>

                <div
                    class="form-group align-items-center mb-1 w-100"
                    v-if="isOrder || enquiry.orderStatusID > 0"
                >
                    <label
                        for="theirOrderNumber"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Their Order Number") }}</strong>
                    </label>
                    <label
                        for="theirOrderNumber"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Their Order Number") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <input
                            type="text"
                            autocomplete="off"
                            v-model="theirOrderNumber"
                            class="form-control w-100"
                            id="theirOrderNumber"
                            :disabled="disabled"
                            :readonly="!isOrder"
                            data-lpignore="true"
                        />
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="selectedBlindShipping"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Blind Shipping Required?") }}</strong>
                    </label>
                    <label
                        for="selectedBlindShipping"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Blind Shipping Required?") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="selectedBlindShipping"
                            id="selectedBlindShipping"
                            class="form-control w-100 custom-select"
                            :disabled="disabled"
                        >
                            <option :value="false">{{ __("No") }}</option>
                            <option :value="true">{{ __("Yes") }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group align-items-center mb-1 w-100">
                    <label
                        for="selectedUrgent"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Is This Enquiry Urgent?") }}</strong>
                    </label>
                    <label
                        for="selectedUrgent"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Is This Enquiry Urgent?") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <select
                            v-model="selectedUrgent"
                            id="selectedUrgent"
                            class="form-control w-100 custom-select"
                            :disabled="disabled"
                        >
                            <option :value="false">{{ __("No") }}</option>
                            <option :value="true">{{ __("Yes") }}</option>
                        </select>
                    </div>
                </div>

                <div
                    class="form-group align-items-center mb-3 w-100"
                    v-if="!isOrder"
                >
                    <label
                        for="quoteNotes"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __("Quotation Notes") }}</strong>
                    </label>
                    <label
                        for="quoteNotes"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __("Quotation Notes") }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <textarea
                            v-model="quoteNotes"
                            class="form-control w-100"
                            id="quoteNotes"
                            rows="8"
                            :disabled="disabled"
                        ></textarea>
                    </div>
                </div>

                <div
                    class="offset-xs-0 offset-xl-3 col-xs-12 col-xl-9 d-flex align-items-center w-100"
                >
                    <button
                        type="submit"
                        class="btn btn-primary"
                        :disabled="updating || disabled"
                    >
                        {{ __("Update") }}
                    </button>

                    <div
                        class="d-flex align-items-center w-100"
                        v-if="updating"
                    >
                        <strong class="ml-4">{{ __("Updating...") }}</strong>
                        <div
                            class="spinner-border ml-auto"
                            role="status"
                            aria-hidden="true"
                        ></div>
                    </div>
                </div>
            </form>
        </div>

        <!-- Modal -->
        <transition name="modal" v-if="userLogModalShown">
            <div class="modal-mask">
                <div
                    class="modal-dialog modal-xl modal-dialog-scrollable"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ __("User Logs") }}</h5>

                            <button
                                type="button"
                                class="close"
                                @click="userLogModalShown = false"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div
                            v-if="!userLogs"
                            class="modal-body d-flex align-items-center"
                        >
                            <strong>{{ __("Loading...") }}</strong>
                            <div
                                class="spinner-border ml-auto"
                                role="status"
                                aria-hidden="true"
                            ></div>
                        </div>

                        <div
                            v-else
                            class="modal-body p-0 justify-content-center table-responsive"
                        >
                            <table
                                class="table table-hover table-light table-bordered table-striped table-sm mb-0"
                            >
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">{{ __("Date") }}</th>
                                        <th scope="col">{{ __("Time") }}</th>
                                        <th scope="col">{{ __("Action") }}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="log in userLogs" :key="log.ID">
                                        <td>{{ formatDate(log.dateTime) }}</td>
                                        <td>{{ formatTime(log.dateTime) }}</td>
                                        <td>{{ log.action }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Modal -->
        <transition name="modal" v-if="splitModalShown">
            <div class="modal-mask">
                <div
                    class="modal-dialog modal-xl modal-dialog-scrollable"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ __("Split Order") }}</h5>

                            <button
                                type="button"
                                class="close"
                                @click="splitModalShown = false"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body p-0">
                            <div
                                class="card"
                                v-for="(part, idx) in enquiry.valid_order_parts"
                                :key="part.ID"
                            >
                                <div class="card-header w-100 mb-0">
                                    <div
                                        class="d-flex justify-content-between my-1"
                                    >
                                        <div class="my-2">
                                            <span>{{
                                                partTitle(idx, part)
                                            }}</span>
                                        </div>

                                        <select
                                            :name="part.ID"
                                            :ref="part.ID"
                                            class="form-control custom-select col-sm-3"
                                        >
                                            <option :value="0" selected>
                                                Move <b>none</b>
                                            </option>
                                            <option
                                                v-for="i in part.qty"
                                                :key="i"
                                                :value="i"
                                            >
                                                Move <b>{{ i }}</b>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            class="btn btn-warning"
                            @click="executeSplit"
                            :disabled="updating || disabled"
                        >
                            Execute Split
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
const dateFns = require('date-fns');

const { format, parse, isValid } = dateFns;

export default {
    name: "EnqFragmentDetails",

    props: {
        enquiry: {
            required: true,
            type: Object,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        updateEnquiry: {
            required: true,
            type: Function,
        },

        isOrder: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            referralMethods: null,
            languageCodes: null,
            loaded: false,
            updating: false,

            // Stuff that's being edited
            selectedReferralMethod: this.enquiry.referral_method_id,
            customersNotes: this.enquiry.customersNotes,
            selectedTemplateID: this.enquiry.templateID,
            theirReferenceNumber: this.enquiry.theirReferenceNumber,
            theirOrderNumber: this.enquiry.theirOrderNumber,
            selectedBlindShipping: this.enquiry.blindShipMarker,
            selectedUrgent: this.enquiry.urgentMarker,
            quoteNotes: this.enquiry.quoteNotes,

            userLogModalShown: false,
            splitModalShown: false,
            userLogs: null,
        };
    },

    computed: {
        validInvoice() {
            const p = parse(
                this.enquiry.dateInvoiced,
                "yyyy-MM-dd HH:mm:ss",
                new Date()
            )
            return isValid(p);
        },

        formattedInvoice() {
            const p =parse(
                this.enquiry.dateInvoiced,
                "yyyy-MM-dd HH:mm:ss",
                new Date()
            );

            return p.toLocaleDateString() + ' @ ' + format(p, 'HH:mm:ss');
        },

        splitable() {
            // orderParts::lineCount($enquiryID) > 1 || orderparts::totalQty($enquiryID) > 1
            let qty = 0;
            let prt = 0;

            this.enquiry.valid_order_parts.forEach((part) => {
                prt++;
                qty += part.qty;
            });

            return prt > 1 || qty > 1;
        },
    },

    methods: {
        formatDate(dateTime) {
            const p =parse(
                dateTime,
                "yyyy-MM-dd HH:mm:ss",
                new Date()
            );

            return p.toLocaleDateString();
        },

        formatTime(dateTime) {
            console.log(dateTime);
            const p = parse(
                dateTime,
                "yyyy-MM-dd HH:mm:ss",
                new Date()
            );
            console.log(p);
            return format(p, 'HH:mm:ss');
        },

        showHistory() {
            this.userLogModalShown = true;
            this.splitModalShown = false;
            this.userLogs = null;

            axios
                .post("/api/enquiries/fragment/details/userLogs", {
                    enquiryID: this.enquiry.id,
                })
                .then((response) => {
                    // console.log(response);
                    this.updating = false;

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.userLogs = data.logs;
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },

        showSplit() {
            this.userLogModalShown = false;
            this.splitModalShown = true;
            this.userLogs = null;
        },

        partTitle(index, _part) {
            let part = _part.part;
            let text =
                (index + 1).toString() +
                ". " +
                part.manufacturer.manufacturerName +
                " " +
                part.partNo;

            return text.slice(0, 45) + (text.length > 45 ? "..." : "");
        },

        executeSplit() {
            let output = {};
            this.updating = true;
            Object.keys(this.$refs).forEach((el) => {
                let ref = this.$refs[el][0];

                if (ref.value != 0) output[el] = ref.value;
            });

            if (_.isEmpty(output)) {
                $("#fail-alert")
                    .text("Please select parts to split.")
                    .slideDown(500)
                    .delay(8000)
                    .slideUp(500);

                return;
            }

            axios
                .post(
                    "/api/enquiries/fragment/details/split/" + this.enquiry.id,
                    output
                )
                .then((response) => {
                    location.reload();
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },

        onSubmit() {
            this.updating = true;

            axios
                .post("/api/enquiries/fragment/details/update", {
                    enquiryID: this.enquiry.id,

                    selectedReferralMethod: this.selectedReferralMethod,
                    // 'customersNotes': this.customersNotes,
                    selectedTemplateID: this.selectedTemplateID,
                    theirReferenceNumber: this.theirReferenceNumber,
                    theirOrderNumber: this.theirOrderNumber,
                    selectedBlindShipping: this.selectedBlindShipping,
                    selectedUrgent: this.selectedUrgent,
                    quoteNotes: this.quoteNotes,
                    forOrder: this.isOrder,
                })
                .then((response) => {
                    // console.log(response);
                    this.updating = false;

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.selectedReferralMethod =
                            data.enquiry.referral_method_id;
                        // this.customersNotes = data.enquiry.customersNotes;
                        this.selectedTemplateID = data.enquiry.templateID;
                        this.theirReferenceNumber =
                            data.enquiry.theirReferenceNumber;
                        // this.theirOrderNumber = data.enquiry.theirOrderNumber;
                        this.selectedBlindShipping =
                            data.enquiry.blindShipMarker;
                        this.selectedUrgent = data.enquiry.urgentMarker;
                        this.quoteNotes = data.enquiry.quoteNotes;

                        this.updateEnquiry(data.enquiry);
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },
    },

    watch: {},

    mounted() {
        axios
            .post("/api/enquiries/fragment/details/get", {
                enquiryID: this.enquiry.id,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;
                    this.referralMethods = data.referal_methods;
                    this.languageCodes = data.language_codes;
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    },
};
</script>
